module.exports = __webpack_public_path__ + "img/logo-mickie-c-storm.66a4c7ce.svg";